import registerAPI from '../../../api/register'
import * as errorMessages from '../../../error-messages'

export default {
  async signUp({commit, state}) {
    commit('forms/signUp/resetErrors')
    commit('forms/signUp/resetSuccess')

    const data = {
      email: state.forms.signUp.fields.email,
      name: state.forms.signUp.fields.name,
      password: state.forms.signUp.fields.password,
      recaptcha_token: state.forms.signUp.fields.recaptcha_token
    }

    try {
      commit('forms/signUp/setSaving', true)
      await registerAPI.signUp(data)
      commit('forms/signUp/setSuccess', true)

    } catch (err) {
      commit('forms/signUp/setSuccess', false)

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/signUp/setErrors', errors)

        } else if (err.response.status === 429) {
          commit('forms/signUp/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
    } finally {
      commit('forms/signUp/setSaving', false)
    }
  },

  async finishRegistration({commit, state}) {
    commit('forms/finishRegistration/resetErrors')
    commit('forms/finishRegistration/resetSuccess')

    const data = {
      email: state.forms.finishRegistration.fields.email,
      name: state.forms.finishRegistration.fields.name,
      password: state.forms.finishRegistration.fields.password,
      password_confirmation: state.forms.finishRegistration.fields.password_confirmation,
      token: state.forms.finishRegistration.fields.token
    }

    try {
      commit('forms/finishRegistration/setSaving', true)
      await registerAPI.finishRegistration(data)
      commit('forms/finishRegistration/setSuccess', true)

    } catch (err) {
      commit('forms/finishRegistration/setSuccess', false)

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/finishRegistration/setErrors', errors)

        } else if (err.response.status === 429) {
          commit('forms/finishRegistration/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
    } finally {
      commit('forms/finishRegistration/setSaving', false)
    }
  },

  async confirmEmail({commit, state}) {
    commit('forms/confirmEmail/resetErrors')
    commit('forms/confirmEmail/resetSuccess')

    const data = {
      email: state.forms.confirmEmail.fields.email,
      token: state.forms.confirmEmail.fields.token
    }

    try {
      commit('forms/confirmEmail/setSaving', true)
      await registerAPI.confirmEmail(data)
      commit('forms/confirmEmail/setSuccess', true)

    } catch (err) {
      commit('forms/confirmEmail/setSuccess', false)

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/confirmEmail/setErrors', errors)

        } else if (err.response.status === 429) {
          commit('forms/confirmEmail/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
    } finally {
      commit('forms/confirmEmail/setSaving', false)
    }
  },

  async forgotPassword({commit, state}) {
    commit('forms/forgotPassword/resetErrors')
    commit('forms/forgotPassword/resetSuccess')

    const data = {
      email: state.forms.forgotPassword.fields.email
    }

    try {
      commit('forms/forgotPassword/setSaving', true)
      await registerAPI.forgotPassword(data)
      commit('forms/forgotPassword/setSuccess', true)

    } catch (err) {
      commit('forms/forgotPassword/setSuccess', false)

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/forgotPassword/setErrors', errors)

          if (errors.email) {
            commit('forms/forgotPassword/setEmailErrors', errors.email)
          }

        } else if (err.response.status === 429) {
          commit('forms/forgotPassword/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
    } finally {
      commit('forms/forgotPassword/setSaving', false)
    }
  },

  async resetPassword({commit, state}) {
    commit('forms/resetPassword/resetErrors')
    commit('forms/resetPassword/resetSuccess')

    const data = {
      email: state.forms.resetPassword.fields.email,
      password: state.forms.resetPassword.fields.password,
      token: state.forms.resetPassword.fields.token
    }

    try {
      commit('forms/resetPassword/setSaving', true)
      await registerAPI.resetPassword(data)
      commit('forms/resetPassword/setSuccess', true)

    } catch (err) {
      commit('forms/resetPassword/setSuccess', false)

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/resetPassword/setErrors', errors)

        } else if (err.response.status === 429) {
          commit('forms/resetPassword/setFieldErrors', {
            field: 'other',
            errors: [errorMessages.TOO_MANY_ATTEMPTS]
          })
        }
      }
    } finally {
      commit('forms/resetPassword/setSaving', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register/actions.js